// Exporting a single icon. We should add more icons as needed.
// eslint-disable-next-line import/no-extraneous-dependencies
export { default as SearchOutline } from '@ant-design/icons/lib/outline/SearchOutline';
